module.exports = "table tbody {\r\n  text-transform: capitalize;\r\n}\r\n\r\ntable td {\r\n  background: #fff;\r\n}\r\n\r\n.bhead {\r\n  margin: 10px 0;\r\n  font-size: 20px;\r\n  color: #522E91;\r\n}\r\n\r\n.table-bordered>thead>tr>th {\r\n  border: 1px solid #7d5ab9 !important;\r\n}\r\n\r\n.notifications {\r\n  padding-top: 20px;\r\n  height: 10px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/audit-log/audit-log.component.css
// module id = ./src/app/admin/audit-log/audit-log.component.css
// module chunks = main